// extracted by mini-css-extract-plugin
export default {"bottomFrame":"ListingTileWithPopup-module__bottomFrame__t7nTE","popupWrapper":"ListingTileWithPopup-module__popupWrapper__Wsi38"};